import { useStoreDispatch } from 'store/hooks/storeHooks';
import { triggerLoginBeforeCheckout } from 'store/slice/accountModalSlice';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.hooks.useLoginBeforeCheckout';

export const useLogInBeforeCheckout = () => {
  const storeDispatch = useStoreDispatch();

  const logInBeforeCheckout = (redirectLink) => {
    storeDispatch(
      triggerLoginBeforeCheckout({
        redirect: redirectLink,
        buttonText: t(`${TP}.buttonText`, 'Proceed to Checkout'),
        title: t(`${TP}.title`, 'Log In to Continue'),
      }),
    );
  };

  return { logInBeforeCheckout };
};
